import { render, staticRenderFns } from "./ParseForm.vue?vue&type=template&id=54df204a&scoped=true&"
import script from "./ParseForm.vue?vue&type=script&lang=js&"
export * from "./ParseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54df204a",
  null
  
)

export default component.exports